import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import {
  createReport,
  createReportTemplate,
  editReportById,
  loadReportTemplateList,
} from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  getFirstFormError, getResponseError, responseLogWithNotification, setFormError,
} from '../../../utils/utils';
import ReportDTO from '../../../dto/ReportDTO';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import { REPORT_TEMPLATE_STATUS } from '../../../configs';
import DatePicker from '../../../components/fields/DatePicker/DatePicker';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { getReportData } from '../reducer';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function ReportForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
    isEdit = false,
  } = props;
  const { formatMessage } = useIntl();
  const [show, setShow] = useState(false);
  const [reportTemplateId, setReportTemplateId] = useState(false);
  const dispatch = useDispatch();
  const {
    loadingReportTemplateList,
    reportTemplateList = [],
  } = useSelector(getReportData);

  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
    setValue,
    watch,
    handleSubmit,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? current : {},
  });

  const currentTemplate = reportTemplateId ? reportTemplateList.find(f => f.id === reportTemplateId) : null;
  const templateAttributes = currentTemplate && currentTemplate.attributes ? currentTemplate.attributes : [];

  useEffect(() => {
    // dispatch(loadTemplateAttributes()).catch(responseLogWithNotification);
    dispatch(loadReportTemplateList({ limit: 50, filter: { status: REPORT_TEMPLATE_STATUS.ACTIVE } })).catch(responseLogWithNotification);
  }, []);

  useEffect(() => {
    if (templateAttributes && templateAttributes.length) {
      setValue('attributes', templateAttributes);
    } else {
      setValue('attributes', []);
    }
  }, [templateAttributes]);

  React.useEffect(() => {
    const subscription = watch(values => {
      if (values && values.report_template_id && typeof values.report_template_id !== 'undefined') {
        setReportTemplateId(values.report_template_id);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Создание отчета', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    const action = isEdit ? editReportById : createReport;
    dispatch(action({ ...values, id: current.id }))
      .then(() => {
        loadData();
        close();
        successNotification('Создание отчета', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Создание отчета', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const handleSaveAsTemplate = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Создание шаблона отчета', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    dispatch(createReportTemplate(values))
      .then(() => {
        loadData();
        successNotification('Создание шаблона отчета', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Создание шаблона отчета', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new ReportDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle
        header={isEdit ? 'Редактирование отчета' : 'Создание отчета'}
        title={<Icons onClick={close} customIcon icon="close" className="close" />}
      />
      <form onSubmit={handleSubmit(handleSave)}>
        <DialogContent className="application-denied-content">
          <TimerLoader loading={loadingReportTemplateList} />
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={CustomSelectInput}
              dtoObject={attributes.report_template_id}
              variant="material"
              withLabel
              options={reportTemplateList.map(i => ({ name: i.name, value: i.id }))}
            />
          </Row>
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DatePicker}
              changeFormat="YYYY-MM-DD"
              dtoObject={attributes.from_date}
              variant="material"
              withLabel
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DatePicker}
              changeFormat="YYYY-MM-DD"
              dtoObject={attributes.to_date}
              variant="material"
              withLabel
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={MultipleSelectInput}
              dtoObject={attributes.attributes}
              withLabel
              variant="material"
              options={(templateAttributes || []).map(i => ({
                name: formatMessage({
                  id: `template.attributes.${i}`,
                  defaultMessage: i,
                }),
                value: i,
              }))}
            />
          </Row>
          <Row onClick={() => setShow(!show)}>
            <Col columns={10}>
              <div className="f4">Сохранить как шаблон</div>
            </Col>
            <Col columns={2}>
              <div className={classNames('show-menu-button', { show })}>
                <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                {show ? 'Свернуть' : 'Развернуть'}
              </div>
            </Col>
          </Row>
          {show
            ? (
              <>
                <Row className="row-cols-1">
                  <FieldDTOWithCol
                    control={control}
                    type="text"
                    component={TextInputWithLabel}
                    dtoObject={attributes.name}
                    withLabel
                    variant="material"
                  />
                </Row>
                <Button
                  className="hff-clear-show mt-3"
                  variant="secondary"
                  type="submit"
                  onClick={handleSaveAsTemplate}
                >Сохранить как шаблон
                </Button>
              </>
            )
            : null}

        </DialogContent>
        <DialogFooter className="hff-footer">
          <div className="hff-footer-buttons">
            <Button className="hff-clear-show" type="submit">Сохранить</Button>
            <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
          </div>
        </DialogFooter>
      </form>
    </Dialog>
  );
}
